import { Component, OnInit } from '@angular/core';

interface UnionStatusData {
  status: string;
  unionName: string;
  reason?: string;
  suspendedAt?: string;
}

@Component({
  selector: 'app-union-suspended',
  templateUrl: './union-suspended.component.html',
  styleUrls: ['./union-suspended.component.scss']
})
export class UnionSuspendedComponent implements OnInit {
  statusData: UnionStatusData | null = null;

  constructor() {}

  ngOnInit(): void {
    this.loadStatusData();
  }

  private loadStatusData(): void {
    const storedData = localStorage.getItem('unionStatusData');
    if (storedData) {
      try {
        this.statusData = JSON.parse(storedData);
      } catch (error) {
        console.error('Error parsing union status data:', error);
      }
    }
  }

  formatDate(dateString: string | undefined): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('bn-BD', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  goToLogin(): void {
    window.location.href = '/auth/login';
  }

  contactSupport(): void {
    // You can customize this with your actual support contact
    window.open('tel:+8801XXXXXXXXX', '_self');
  }
}